import Data from "../types/Data";

export default function getAllGroupIds(data: Data) {
  if (data.personIds.length > 1) {
    return [0, ...data.groupIds];
  } else {
    return data.groupIds;
  }
}
